<template>
    <RichResponseListItem
        iconType="text"
        icon="?"
        icon-blurred
        title="Anfrage an das IBFG Team senden."
        :selectable="false"
        v-on:click="onClick"
        :button="true"
    />
    <InitHumanRequestModal ref='modal' v-model="modalValue" v-on:submit="onSubmit"/>
</template>

<script setup lang="ts">
import RichResponseListItem from "./components/RichResponseListItem.vue"
import {ref, Ref} from "vue";
import {sendUserMessage} from "@/helper/chat/chatBL";
import InitHumanRequestModal from "@/views/components/InitHumanRequestModal.vue";
import {HumanRequest} from "@/graphql/generated/graphql";
import {addHumanRequest} from "@/helper/chat/humanRequests";
import {kapitelErrorHandler} from "@/helper/error";


const modal = ref()
const modalValue: Ref<boolean> = ref(false)
const onClick = () => {
    modalValue.value = true
}

const onSubmit = (request: HumanRequest) => {
    addHumanRequest(request)
        .catch(kapitelErrorHandler)
        .then(
            () => sendUserMessage(
                "Vielen Dank, dass du mir die RichResponse angezeigt hast. Ich konnte darüber jetzt eine Anfrage an das IBFG Team absenden und bin gespannt auf die Antwort.",
                {isScriptedContent: true}
            ))
}


</script>
